const awsmobile =  {
  "aws_project_region": "us-west-2",
  "aws_cognito_region": "us-west-2",
  "aws_user_pools_id": "us-west-2_eT8izvr2l",
  "aws_user_pools_web_client_id": "4pdegdnio80ogsl9hja00orhu0",
  "aws_cloud_logic_custom": [
    {
      "name": "mapApi",
      "endpoint": "https://88s34h7jbi.execute-api.us-west-2.amazonaws.com/Dev1",
      "region": "us-west-2"
    },
    {
      "name": "api",
      "endpoint": "https://l5od6ljw50.execute-api.us-west-2.amazonaws.com/riparian-production",
      "region": "us-west-2",
      "userBucket": "riparian-production-user-data"
    }
  ]
};

export default awsmobile;
